export default __webpack_public_path__ + "static/jesseBerwald-2e26396e592b808b71bd4270b2e60528.jpg";